module.exports = __webpack_public_path__ + "static/media/arrow-left-md-dark.8e3f0dd4.svg";